// removed by extract-text-webpack-plugin
module.exports = {"colors":"#78C144, #3374D5, #F85757, #F2A725, #F225EB","rgbs":"120, 193, 68, 51, 116, 213, 248, 87, 87, 242, 167, 37, 242, 37, 235"};


//////////////////
// WEBPACK FOOTER
// ./src/apps/feelgrid/scss/_variables.scss
// module id = q1/E
// module chunks = 13